import {Component, EventEmitter, Input, OnInit, Output} from '@angular/core';
import {INVISEO_VARIABLE_WIDGETS, WidgetName} from '../../../../../domain/widget/model/widget-name.enum';
import {WidgetService} from '../../../../../domain/widget/service/widget.service';
import {WidgetDetail} from '../../../../../domain/widget/model/widget-detail';
import {SafeSubscriberDirective} from '../../../../../application/app-context/safe-subscriber.directive';
import {WidgetSize} from '../../../../../domain/widget/model/widget-size.enum';
import {AnalyticsCategory} from '../../../../../application/analytics/analytics-category';
import {AnalyticsEventType} from '../../../../../application/analytics/analytics-event-type';
import {AmplitudeService} from '../../../../../application/analytics/service/amplitude.service';
import {TranslateService} from '@ngx-translate/core';

export enum ResultState {
  IN_PROGRESS = 'IN_PROGRESS',
  SUCCESS = 'SUCCESS',
  ERROR = 'ERROR'
}

@Component({
  selector: 'app-widget',
  templateUrl: './home-dashboard-widget.component.html'
})
export class HomeDashboardWidgetComponent extends SafeSubscriberDirective implements OnInit {

  readonly WidgetName = WidgetName;
  readonly INVISEO_VARIABLE_WIDGETS = INVISEO_VARIABLE_WIDGETS;

  @Input() widget: WidgetDetail | undefined;
  @Input() dashboardId: number | undefined;
  @Input() isEditable = false;
  @Input() isMocked = false;

  widgetData: any;
  resultState = ResultState.IN_PROGRESS;
  WidgetSize = WidgetSize;

  @Output() removeWidget: EventEmitter<WidgetDetail> = new EventEmitter<WidgetDetail>();

  constructor(private widgetService: WidgetService,
              private translateService: TranslateService,
              private amplitudeService: AmplitudeService) {
    super();
  }

  ngOnInit(): void {
    if (this.widget !== undefined) {
      this.subs.push(
        this.widgetService.retrieveWidgetData(this.widget.widgetName, this.widget.size, this.isMocked)
            .subscribe((result: any) => {
              this.widgetData = result;
              this.resultState = ResultState.SUCCESS;
            }, error => {
              this.resultState = ResultState.ERROR;
            })
      );
    }
  }

  public removeWidgetFromDashboard(): void {
    if (this.dashboardId && this.widget) {
      this.widgetService.removeWidget(this.dashboardId, this.widget.id)
          .subscribe((result: boolean) => {
            if (result) {
              this.removeWidget.emit(this.widget);
            }
          });
    }
  }

  public isSmallWidget(): boolean {
    return this.widget.size === WidgetSize.SMALL;
  }

  public trackAction(actionKey: string): void {
    const eventProperties = new Map<string, string>();
    eventProperties.set('CodeWidget', this.widget.widgetName);
    eventProperties.set('Categorie', this.widget.applicationNames.toString());
    eventProperties.set('Action', this.translateService.instant(actionKey));
    this.amplitudeService.trackEventAction(AnalyticsCategory.widget, AnalyticsEventType.actionTools, eventProperties);
  }
}
